module.exports = __webpack_public_path__ + "static/media/invite_bg.f70e7074.jpg";